import type { IconName } from '@components/Icon/BaseIcon';

import { Component } from 'react';

export interface ActionItemProps {
  /**
   * Styles override.
   */
  className?: string;
  /**
   * Icon to be shown for the action.
   */
  icon: IconName;
  /**
   * Should the action be disabled.
   */
  isDisabled?: boolean;
  /**
   * Callback when the action is pressed.
   */
  onClick: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
  /**
   * Accessible description of the action. Shown in a tooltip and in ARIA attributes.
   * Provides context for the icon.
   */
  description: string;
}

/**
 * Use ActionMenu.Item for actions inside an ActionMenu.
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-actionmenu--action-menu Code documentation}
 *
 * @example
 * <ActionMenu.Item icon="" onClick={} description="" isDisabled />
 */
export class ActionItem extends Component<ActionItemProps> {}
